import {ChangeDetectionStrategy, Component, computed, inject, input} from "@angular/core";
import {
  bzIconAccount, bzIconBusiness, bzIconCalendarOutline, bzIconCustomerOutline, bzIconDepot, bzIconEta, bzIconEtd,
  bzIconLocationPin, bzIconLocationPinPlusOutline, bzIconPhoneOutline,
} from "@bringoz/ui/icons";
import {LocationType} from "../../../../commons/types/location.type";
import {ThreePLServiceTask} from "../../models/threepl-service-details.model";
import {SplitService} from "../../../../commons/services/split-service.service";

require("./threepl-service-task.scss");

@Component({
  selector: "app-threepl-service-task",
  templateUrl: "./threepl-service-task.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceTaskComponent {
  readonly task = input.required<ThreePLServiceTask>();

  readonly configZoneId = inject<SplitService>("splitService" as never).getTimeZone();
  readonly locationTypes = LocationType;

  readonly locationRef = computed(() => ({id: this.task().locationDetails?.id, name: this.task().contact?.fullName}));
  readonly icons = {
    address: bzIconLocationPin, business: bzIconBusiness, phone: bzIconPhoneOutline,
    eta: bzIconEta, etd: bzIconEtd, window: bzIconCalendarOutline,
    account: bzIconAccount, depot: bzIconDepot, customer: bzIconCustomerOutline, custom: bzIconLocationPinPlusOutline,
  };
}
